import React, { useRef } from 'react';
import { DropdownIcon } from 'Components/Common/Select/CustomSelect/DropdownIcon';
import { SearchIcon } from 'Components/Common/Select/CustomSelect/SearchIcon';
import { ClearIcon } from 'Components/Common/Select/CustomSelect/ClearIcon';
interface SearchInputProps {
  searchString?: string;
  setSearchString: ({ target }: { target: EventTarget }) => void;
  onBlur?: () => void;
  onEnter?: (e: React.KeyboardEvent<EventTarget>) => void;
  onFocus?: () => void;
  onClear?: () => void;
  placeholder?: string;
  showIcon?: boolean;
  showIconClear?: boolean;
  classInput?: string;
}

const SearchInput = (props: SearchInputProps): JSX.Element => {
  const {
    searchString,
    setSearchString,
    onBlur,
    onEnter,
    onFocus,
    onClear,
    placeholder,
    showIcon = true,
    showIconClear = false,
    classInput = '',
  } = props;
  const ref = useRef<HTMLInputElement>(null);

  const handleOnFocus = () => {
    onFocus && onFocus();
    if (ref) {
      ref.current?.focus();
    }
  };

  return (
    <div className="search-input pe-5" onClick={handleOnFocus} aria-hidden>
      <SearchIcon showIcon={showIcon} />
      <input
        ref={ref}
        spellCheck={false}
        value={searchString ?? ''}
        onChange={setSearchString}
        onBlur={onBlur}
        placeholder={placeholder}
        onKeyDown={onEnter}
        className={classInput}
      />
      <div onClick={onClear} onKeyDown={onClear} hidden={!showIconClear}>
        {searchString && <ClearIcon />}
      </div>
      <DropdownIcon />
    </div>
  );
};

export default SearchInput;
